module.exports = __webpack_public_path__ + "img/grade2.42a7240c.png";